import { useEffect, useState } from "react";

/**
 * A stored image URL can outlive the file behind it — a failed upload, a deleted
 * asset, a CDN link that never got written. Treat a URL that won't load as no
 * image at all, so the caller renders its own placeholder (category icon,
 * initials, club name) instead of the browser's broken-image glyph.
 */
export default function useImageFallback(src) {
  const [failed, setFailed] = useState(false);

  useEffect(() => setFailed(false), [src]);

  return { showImage: !!src && !failed, onImageError: () => setFailed(true) };
}
